<template>
  <sl-side-panel :width="80" v-model="visible" :mask-closable="false" title="下级网点">
    <sl-table ref="table" :loading="loading" :columns="columns" :data="data" :page="false"></sl-table>
  </sl-side-panel>
</template>
<script>

const columns_ = [
  {
    title: '企业名称',
    key: 'title',
    width: 180,
  },
  {
    title: '企业性质',
    key: 'companyNatureText',
    width: 100,
  },
  {
    title: '统一信用代码',
    key: 'unionCreditCode',
    width: 150,
  },
  {
    title: '负责人',
    key: 'legalName',
    width: 100,
  },
  {
    title: '联系电话',
    key: 'companyPhone',
    width: 150,
  },
  {
    title: '所属品牌',
    key: 'brandName',
    width: 150,
  },
  {
    title: '成立时间',
    key: 'establishDatetimeText',
    width: 150,
  },
  {
    title: '状态',
    key: 'stateText',
    width: 100,
  }
]

const flatten = (arr, l = 0) => arr.reduce((prev, item) => prev.concat(Object.assign(item,{l}), Array.isArray(item.children) && item.children.length ? flatten(item.children, l++) : []), [])

const title = d => d.l > 0 ? (new Array(d.l+1).fill(' ') + '|-' + d.companyName) : d.companyName  

export default {
  components: { },
  data() {
    return {
      columns: [
        ...columns_,
        /*{
          title: '操作',
          key: 'action',
          width: 150,
          fixed: "right",
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params)
                  }
                }
              }, '编辑'),
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.toggle(params)
                  }
                }
              }, params.state == 1 ? '启用' : '禁用')
            ])
          }
        }*/
      ],
      data: [],

      loading: false,
      visible: false,
      itemTitle: '',
    }
  },


  methods: {
    init(id) {
      this.id = id
      this.visible = true
      this.list()
    },

    list() {
      let params = { search: { parentId: this.id, companyType: 1 }, pageSize: 9999, pageNum: 1 }
      this.loading = true
      this.$request.companiesByParent(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          let d = 

          this.data = this.$utils.conv(
            flatten(this.$utils.tree(resp.data.list, 'id', 'parentId', 'children', this.id)), 
            { 'establishDatetime': 'datetime', 'companyType': '$companyType', 'state': '$enable', 'companyNature': '$companyNature', 'location': 'area' , title }
          )

        }
      })
    },
    remove({ row }) {
      this.$ui.confirm(this.$request.companyDelete, `确定删除 ${row.companyName} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.selection = []
          this.list()
        }
      })
    },

    toggle({ row }) {
      this.$request.companyToggle(row.id).then(resp => {
        if (resp.code) {
          this.$Message.error(resp.msg)
        } else {
          this.$Message.success('操作成功')
          this.selection = []
          this.list()
        }
      })
    },

    reset() {
      this.$utils.fill(this.params, this.def)
      console.log(this.params)
      this.list()
    },

    viewChildren({ row }) {
      this.$refs['branch'].init(row.id)
    },

    handleUpdate() {
      this.visible = false
      this.list()
    }
  }
}

</script>
